import { SupportedAudioFileType } from "@/types/types";

export const isSupportedFileType = (
  fileType: unknown
): fileType is SupportedAudioFileType => {
  return (
    typeof fileType === "string" &&
    ["wav", "mp3", "flac", "ogg", "m4a", "aif", "aiff"].includes(fileType)
  );
};
